// extracted by mini-css-extract-plugin
export var activityContainer = "_ly-0";
export var typingIndicatorContainer = "_ly-1";
export var typingIndicatorDot = "_ly-2";
export var wave = "_ly-3";